export default __webpack_public_path__ + "static/media/905.e46b23ba.png";